import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { list_template } from '@/graphql/queries'

export default {
  data() {
    return {
      templatesList: [],
    }
  },
  methods: {
    async fetchTemplates(categoryId = null) {
      try {
        const input = {};
        if (categoryId) {
          input.category_id = categoryId;
        }
        input.source = "BMS";

        const response = await client.graphql({
          query: list_template,
          variables: {
            input: input
          }
        })

        let responseData = JSON.parse(response.data.list_template)
        // console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.templatesList = responseData.data || []
        } else {
          this.templatesList = []
        }
        // console.log(this.templatesList)

      } catch (error) {
        console.error("Error fetching templates:", error);
        if (error == 'NoValidAuthTokens: No federated jwt') {
          this.$router.push("/login");
          this.$store.dispatch("logout");
          this.$store.dispatch("clearAuth");
          this.$store.dispatch("clearUser");
          this.$store.dispatch("clearToken");
          this.$store.dispatch("clearRefreshToken");
          this.$store.dispatch("clearExpiresAt");
          this.$store.dispatch("clearExpiresIn");
        }
        this.templatesList = [];
        throw error;
      }
    },
  },
};

